"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_PRODUCT_FLAVOR = void 0;
var client_1 = require("@apollo/client");
exports.CREATE_PRODUCT_FLAVOR = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation CreateFlavor($flavor: String!) {\n    createProductFlavor(flavor:$flavor) {\n      productFlavor {\n        id\n        flavor\n        displayFlavor\n      }\n    }\n  }\n"], ["\n  mutation CreateFlavor($flavor: String!) {\n    createProductFlavor(flavor:$flavor) {\n      productFlavor {\n        id\n        flavor\n        displayFlavor\n      }\n    }\n  }\n"])));
var templateObject_1;
